import { ForbiddenError, HttpStatusCodes, Result } from '@resourceful-hono/core';
import { BaseResource } from '../BaseResource.ts';
import { Protected } from '../common/decorators.ts';
import { Permissions } from '../../../services/OAuth/enums.ts';
import { Game, UserAccount } from '../../../entities/index.ts';

export class UserAccountResource extends BaseResource {
  @Protected([Permissions.GetAccount])
  public async GET() {
    const game = await Game.findOne({
      where: {
        players: {
          id: this.userId,
        },
      },
    });
    if (!game)
      throw new ForbiddenError('You need to be in a game.');
    const account = await UserAccount.findOne({
      where: {
        owner: { id: this.userId },
      },
    }).then(async (account) => {
      if (!account) throw new ForbiddenError();
      return {
        ...account,
        lastTransactionId: await account.getLastTransactionId(game.id),
        balance: await account.getBalance(game.id),
      };
    });

    return Result(HttpStatusCodes.Ok, account);
  }
}